import React from 'react';
import './AdminLayout.css';
import TopNavigationBar from 'screens/Main/components/TopNavigationBar';
import Footer from 'components/Footer';
import AdminSidebar from './components/AdminSidebar';
import { useState, useEffect } from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  currentPath: string;
}

const AdminLayout: React.FC<Props> = ({ title, children, currentPath }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="App">
      <div className="main">
        {/* Admin Sidebar */}
        <AdminSidebar 
          currentPath={currentPath}
          isMobile={isMobile}
          isMobileMenuOpen={isMobileMenuOpen}
          onMenuClose={() => setIsMobileMenuOpen(false)}
        />

        {/* Main content area */}
        <div className="content">
          {/* Header */}
          <TopNavigationBar 
            title={title}
            isMobileMenuOpen={isMobileMenuOpen}
            onToggleMobileMenu={toggleMobileMenu}
          />

          {/* Admin Content */}
          <div className="main-content-wrapper">
            <div className="main-page-content">{children}</div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AdminLayout;